import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CountryService } from '@services/country.service';
import { EnvironmentService } from '@services/environment.service';
import { v5 } from 'uuid';

export const apiUrlInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.url.includes('assets')) {
        return next(request);
    }

    const countryService = inject(CountryService);
    const environmentService = inject(EnvironmentService);

    const { baseUrl, version } = environmentService.getEnvinronment().apiConfig;
    const currentCountry = countryService.getCurrentCountry();

    const modified = request.clone({
        url: `${baseUrl}/api/v${version}/${request.url}`,
        params: request.params.append('transactionId', v5.URL).set('countryCode', currentCountry),
    });

    return next(modified);
};
